/* SECURITIES */
export const GET_SECURITIES = 'GET_SECURITIES';
export const GET_SECURITIES_SUCCESS = 'GET_SECURITIES_SUCCESS';
export const GET_SECURITIES_FAILURE = 'GET_SECURITIES_FAILURE';

/* SECURITY */
export const GET_SECURITY = 'GET_SECURITY';
export const GET_SECURITY_SUCCESS = 'GET_SECURITY_SUCCESS';
export const GET_SECURITY_FAILURE = 'GET_SECURITY_FAILURE';
